/** Velocità dello scorrimento dei nomi lunghi, in px al secondo: abbastanza lenta da leggere su un telefono. */
const SPEED = 30
/** Quota del ciclo in movimento (andata + ritorno); il resto sono le pause ai due capi (keyframes `name-scroll`). */
const MOVING_SHARE = 0.6
const MIN_DURATION = 5

/**
 * Scorrimento di un nome che non entra nel suo spazio: di quanti px spostarlo e quanto dura un ciclo
 * (pausa, andata, pausa, ritorno). Null se il nome ci sta: sotto un pixel di differenza è solo arrotondamento.
 */
export function marqueeTiming(containerWidth: number, contentWidth: number): { shift: number; duration: number } | null {
  const shift = contentWidth - containerWidth
  if (shift < 1) return null
  return { shift, duration: Math.max(MIN_DURATION, (2 * shift) / SPEED / MOVING_SHARE) }
}
